module.exports = {
	"de": {
		"nav": {
			"products": "Produkte",
			"contact": "Kontakt"
		},
		"tagline": {
			"start": "Produkte für",
			"emphasis": "spirituelle ",
			"end": "Anwendungen."
		},
		"social": "Finde uns auf"
	},
	"en": {
		"nav": {
			"products": "Products",
			"contact": "Contact"
		},
		"tagline": {
			"start": "Products for ",
			"emphasis": "spiritual ",
			"end": "applications."
		},
		"social": "Find us on"
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/header/locales.json
// module id = 63
// module chunks = 0